import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1030.97491,188 L1112.22371,269.248803 L682.995595,698.47692 L983.742578,698.47692 C1499.96552,698.47692 1920,1118.5114 1920,1634.73434 L1920,1634.73434 L1920,1732.76154 L1805.07949,1732.76154 L1805.07949,1634.73434 C1805.07949,1181.8326 1436.64432,813.397433 983.742578,813.397433 L983.742578,813.397433 L682.995595,813.397433 L1112.22371,1242.62555 L1030.97491,1323.87435 L463.037732,755.937177 L1030.97491,188 Z M567.937177,188.011492 L649.18598,269.260295 L162.497606,755.948669 L649.18598,1242.63704 L567.937177,1323.88585 L0,755.948669 L567.937177,188.011492 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconReplyAll2Line = /*#__PURE__*/function (_Component) {
  _inherits(IconReplyAll2Line, _Component);

  var _super = _createSuper(IconReplyAll2Line);

  function IconReplyAll2Line() {
    _classCallCheck(this, IconReplyAll2Line);

    return _super.apply(this, arguments);
  }

  _createClass(IconReplyAll2Line, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconReplyAll2",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconReplyAll2Line.displayName = "IconReplyAll2Line";
  return IconReplyAll2Line;
}(Component);

IconReplyAll2Line.glyphName = 'reply-all-2';
IconReplyAll2Line.variant = 'Line';
IconReplyAll2Line.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconReplyAll2Line;
export { IconReplyAll2Line };